import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {ButtonModule} from 'primeng/button';

@Component({
  selector: 'app-add-item-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonModule, TranslocoPipe],
  templateUrl: './add-item-button.component.html',
})
export class AddItemButtonComponent {
  label = input<string>('common.item.add');
  disabled = input<boolean>(false);
  testId = input<string>('add-item-button');

  add = output<void>();
}
